const transitionLogicData = {
    invoiceToCreditNote: [
        // Does some change of some sort 
        {
            operationType: 'changeValues',
            fields: [
                {
                    targetField: 'entity',
                    fromValue: 'invoice',
                    toValue: 'creditNote'
                },
                {
                    targetField: 'date',
                    toValue: '{today}'
                },
                {
                    targetField: 'paymentDate',
                    toValue: '{today}'
                },
                {
                    targetField: 'linkedDocumentNumber',
                    toValue: 'bookedNumber'
                },
                {
                    targetField: 'state',
                    fromValue: 'final',
                    toValue: 'draft'
                },
                {
                    targetField: 'terms',
                    toValue: ''
                },
                {
                    targetField: 'number',
                    toValue: 'settings/nSeries/creditNote/nextValue'
                },
                {
                    targetField: 'bookedNumber',
                    toValue: 'DRAFT'
                },
                {
                    targetField: 'nSerie',
                    toValue: 'settings/nSeries/creditNote/id'
                },
                {
                    targetField: 'linkedDocumentId',
                    sourceField: 'id'
                },
                {
                    targetField: 'id',
                    toValue: false
                }
            ]
        },
        {
            operationType: 'deleteFields',
            fields: ['payments', 'paymentType', 'numPayments', 'paymentSchedule', 'paymentIntervalDays', 'paymentTermDays', 'paymentTermId', 'paymentTermName',
                'documentDiscountAmount', 'documentDiscountAmountBaseCurrency', 'totalNetSalesAmountBeforeDiscount']
        },
        {
            operationType: 'reduceArray',
            sourceArray: 'linkedDocuments',
            sourceSubArray: 'lines',
            targetArray: 'lines',
            targetFields: ['itemQuantity'],
            // The discount definition travels; what it computed does not. A
            // credit note recalculates from discountType and discountValue
            // against whatever quantities it actually credits, which is the
            // point of storing the definition rather than only the money.
            targetRemoveFields: ['netSalesAmount', 'taxAmount',
                'netSalesAmountBeforeDiscount', 'discountAmount']
        }
    ],
    quoteToInvoice: [
        {
            operationType: 'changeValues',
            fields: [
                {
                    targetField: 'entity',
                    fromValue: 'quote',
                    toValue: 'invoice'
                },
                {
                    targetField: 'date',
                    toValue: '{today}'
                },
                {
                    targetField: 'linkedDocumentNumber',
                    toValue: 'bookedNumber'
                },
                {
                    targetField: 'state',
                    fromValue: 'final',
                    toValue: 'draft'
                },
                {
                    targetField: 'number',
                    toValue: 'settings/nSeries/invoice/nextValue'
                },
                {
                    targetField: 'bookedNumber',
                    toValue: 'DRAFT'
                },
                {
                    targetField: 'nSerie',
                    toValue: 'settings/nSeries/invoice/id'
                },
                {
                    targetField: 'linkedDocumentId',
                    sourceField: 'id'
                },
                {
                    targetField: 'id',
                    toValue: false
                }
            ]
        },
        {
            operationType: 'deleteFields',
            fields: ['expiryDate',
                'documentDiscountAmount', 'documentDiscountAmountBaseCurrency', 'totalNetSalesAmountBeforeDiscount']
        }
    ],
    quoteToShipment: [
        {
            operationType: 'changeValues',
            fields: [
                { targetField: 'entity',              fromValue: 'quote', toValue: 'stockShipment' },
                { targetField: 'date',                toValue: '{today}' },
                { targetField: 'linkedDocumentNumber', toValue: 'bookedNumber' },
                { targetField: 'state',               fromValue: 'final', toValue: 'draft' },
                { targetField: 'number',              toValue: 'settings/nSeries/stockShipment/nextValue' },
                { targetField: 'bookedNumber',        toValue: 'DRAFT' },
                { targetField: 'nSerie',              toValue: 'settings/nSeries/stockShipment/id' },
                { targetField: 'linkedDocumentId',    sourceField: 'id' },
                { targetField: 'id',                  toValue: false }
            ]
        },
        {
            operationType: 'deleteFields',
            fields: [
                'expiryDate', 'vatTaxes',
                'totalGrossSalesAmount', 'totalGrossSalesAmountBaseCurrency',
                'totalNetSalesAmount', 'totalNetSalesAmountBaseCurrency',
                'totalVatTaxAmount', 'totalVatTaxAmountBaseCurrency',
                'totalNetSalesAmountBeforeDiscount',
                'documentDiscountType', 'documentDiscountValue',
                'documentDiscountAmount', 'documentDiscountAmountBaseCurrency',
                'roundingAmount', 'currency', 'exchangeRate',
                'priceListId', 'priceListName', 'terms',
                'campaignId', 'campaignCode', 'customerGroupId', 'customerGroupName',
                'paymentTermId', 'paymentTermName', 'paymentTermDays',
                'paymentDate', 'paymentDateCalculation', 'numPayments',
                'payments', 'paymentType', 'paymentSchedule', 'paymentIntervalDays'
            ]
        },
        {
            operationType: 'buildLinesFromArray',
            sourceArray: 'lines',
            targetArray: 'lines',
            fieldMap: [
                { targetField: 'itemId',          sourceField: 'itemId' },
                { targetField: 'itemName',        sourceField: 'itemName' },
                { targetField: 'itemDescription', sourceField: 'itemDescription' },
                { targetField: 'itemQuantity',    sourceField: 'itemQuantity' },
                { targetField: 'unitId',          sourceField: 'unitId' },
                { targetField: 'unitName',        sourceField: 'unitName' }
            ]
        }
    ],
    purchaseOrderToStockReceipt: [
        {
            operationType: 'changeValues',
            fields: [
                { targetField: 'entity',               fromValue: 'purchaseOrder', toValue: 'stockReceipt' },
                { targetField: 'date',                 toValue: '{today}' },
                { targetField: 'linkedDocumentNumber', toValue: 'bookedNumber' },
                { targetField: 'state',                fromValue: 'final', toValue: 'draft' },
                { targetField: 'number',               toValue: 'settings/nSeries/stockReceipt/nextValue' },
                { targetField: 'bookedNumber',         toValue: 'DRAFT' },
                { targetField: 'nSerie',               toValue: 'settings/nSeries/stockReceipt/id' },
                { targetField: 'linkedDocumentId',     sourceField: 'id' },
                { targetField: 'purchaseOrderId',      sourceField: 'id' },
                { targetField: 'purchaseOrderNumber',  sourceField: 'bookedNumber' },
                { targetField: 'id',                   toValue: false }
            ]
        },
        {
            operationType: 'deleteFields',
            fields: [
                'deliveryDate', 'currency', 'exchangeRate', 'currencyName',
                'vatTaxes', 'totalGrossAmount', 'totalNetAmount', 'totalVatAmount',
                'totalGrossSalesAmount', 'totalNetSalesAmount', 'totalVatTaxAmount',
                'paymentTermId', 'paymentTermName', 'paymentTermDays',
                'paymentDate', 'paymentType', 'payments', 'notes', 'expiryDate'
            ]
        },
        {
            operationType: 'buildLinesFromArray',
            sourceArray: 'lines',
            targetArray: 'lines',
            fieldMap: [
                { targetField: 'itemId',          sourceField: 'itemId' },
                { targetField: 'itemName',        sourceField: 'itemName' },
                { targetField: 'itemDescription', sourceField: 'itemDescription' },
                { targetField: 'itemQuantity',    sourceField: 'quantityOrdered' },
                { targetField: 'unitId',          sourceField: 'unitId' },
                { targetField: 'unitName',        sourceField: 'unitName' }
            ]
        }
    ],
    // The page loads nothing itself (load: false); the purchase order arrives as
    // addData, so every field is copied across explicitly rather than inherited.
    purchaseOrderToExpense: [
        {
            operationType: 'addFields',
            fields: [
                { targetField: 'purchaseOrderId',          sourceField: 'id' },
                { targetField: 'purchaseOrderNumber',      sourceField: 'bookedNumber' },
                { targetField: 'supplierId',               sourceField: 'supplierId' },
                { targetField: 'supplierName',             sourceField: 'supplierName' },
                { targetField: 'supplierEmail',            sourceField: 'supplierEmail' },
                { targetField: 'supplierAddress_street',   sourceField: 'supplierAddress_street' },
                { targetField: 'supplierAddress_postCode', sourceField: 'supplierAddress_postCode' },
                { targetField: 'supplierAddress_city',     sourceField: 'supplierAddress_city' },
                { targetField: 'supplierAddress_region',   sourceField: 'supplierAddress_region' },
                { targetField: 'supplierCountry',          sourceField: 'supplierCountry' },
                { targetField: 'supplierCountryName',      sourceField: 'supplierCountryName' },
                { targetField: 'companyTypeId',            sourceField: 'companyTypeId' },
                { targetField: 'currency',                 sourceField: 'currency' },
                { targetField: 'currencyName',             sourceField: 'currencyName' },
                { targetField: 'exchangeRate',             sourceField: 'exchangeRate' },
                { targetField: 'language',                 sourceField: 'language' },
                { targetField: 'languageName',             sourceField: 'languageName' },
                { targetField: 'paymentTermId',            sourceField: 'paymentTermId' },
                { targetField: 'paymentTermName',          sourceField: 'paymentTermName' },
                { targetField: 'paymentTermDays',          sourceField: 'paymentTermDays' },
                { targetField: 'paymentDate',              sourceField: 'paymentDate' },
                { targetField: 'savedOn',                  toValue: '{today}' }
            ]
        },
        {
            operationType: 'changeValues',
            fields: [
                { targetField: 'entity',       toValue: 'expense' },
                { targetField: 'source',       toValue: 'purchaseOrder' },
                { targetField: 'state',        toValue: 'draft' },
                { targetField: 'date',         toValue: '{today}' },
                { targetField: 'number',       toValue: 'settings/nSeries/expense/nextValue' },
                { targetField: 'bookedNumber', toValue: 'DRAFT' },
                { targetField: 'nSerie',       toValue: 'settings/nSeries/expense/id' }
            ]
        },
        {
            operationType: 'deleteFields',
            fields: ['id']
        },
        {
            operationType: 'buildLinesFromArray',
            sourceArray: 'lines',
            targetArray: 'lines',
            fieldMap: [
                { targetField: 'itemId',          sourceField: 'itemId' },
                { targetField: 'itemName',        sourceField: 'itemName' },
                { targetField: 'itemDescription', sourceField: 'itemDescription' },
                { targetField: 'itemType',        sourceField: 'itemType' },
                { targetField: 'itemQuantity',    sourceField: 'quantityOrdered' },
                { targetField: 'unitId',          sourceField: 'unitId' },
                { targetField: 'unitName',        sourceField: 'unitName' },
                { targetField: 'unitPrice',       sourceField: 'unitPrice' },
                { targetField: 'itemTaxId',       sourceField: 'itemTaxId' },
                { targetField: 'itemTaxName',     sourceField: 'itemTaxName' },
                { targetField: 'itemTaxRate',     sourceField: 'itemTaxRate' }
            ]
        }
    ],
    // A Purchases › Inbox document (38.04) becomes a draft expense with the
    // document attached — the inbox entry keeps it in the expense's own
    // attachment shape. Everything else comes from the suggestion panel.
    inboxDocumentToExpense: [
        {
            operationType: 'addFields',
            fields: [
                { targetField: 'inboxDocumentId', sourceField: 'id' },
                { targetField: 'attachments',     sourceField: 'attachments' },
                { targetField: 'savedOn',         toValue: '{today}' }
            ]
        },
        {
            operationType: 'changeValues',
            fields: [
                { targetField: 'entity',       toValue: 'expense' },
                { targetField: 'source',       toValue: 'manual' },
                { targetField: 'state',        toValue: 'draft' },
                { targetField: 'date',         toValue: '{today}' },
                { targetField: 'number',       toValue: 'settings/nSeries/expense/nextValue' },
                { targetField: 'bookedNumber', toValue: 'DRAFT' },
                { targetField: 'nSerie',       toValue: 'settings/nSeries/expense/id' }
            ]
        },
        {
            operationType: 'deleteFields',
            fields: ['id']
        }
    ],
    contactToInvoice: [
        {
            operationType: 'addFields',
            fields: [
                {
                    targetField: 'customerId',
                    sourceField: 'id'
                },
                {
                    targetField: 'customerName',
                    sourceField: 'name'
                },
                {
                    targetField: 'companyTypeId',
                    sourceField: 'companyTypeId'
                },
                {
                    targetField: 'customerEmail',
                    sourceField: 'email'
                },
                {
                    targetField: 'customerAddress_city',
                    sourceField: 'address_city'
                },
                {
                    targetField: 'customerAddress_street',
                    sourceField: 'address_street'
                },
                {
                    targetField: 'customerAddress_postCode',
                    sourceField: 'address_postCode'
                },
                {
                    targetField: 'customerCountry',
                    sourceField: 'country'
                },
                {
                    targetField: 'customerCountryName',
                    sourceField: 'countryName'
                },
                {
                    targetField: 'savedOn',
                    toValue: '{today}'
                }
            ]
        }
    ],
    projectToInvoice: [
        // Copy fields from project data (addData) into invoice
        {
            operationType: 'addFields',
            fields: [
                { targetField: 'companyTypeId',    sourceField: 'companyTypeId' },
                { targetField: 'customerId',        sourceField: 'contactId' },
                { targetField: 'customerName',      sourceField: 'contactName' },
                { targetField: 'contactPersonId',   sourceField: 'contactPersonId' },
                { targetField: 'contactPersonName', sourceField: 'contactPersonName' },
                { targetField: 'customerAddress_street', sourceField: 'contactAddress_street' },
                { targetField: 'customerAddress_city', sourceField: 'contactAddress_city' },
                { targetField: 'customerAddress_postCode', sourceField: 'contactAddress_postCode' },
                { targetField: 'customerAddress_region', sourceField: 'contactAddress_region' },
                { targetField: 'customerCountry', sourceField: 'contactCountry' },
                { targetField: 'customerCountryName', sourceField: 'contactCountryName' },
                { targetField: 'customerEmail', sourceField: 'contactEmail' },
                { targetField: 'projectId', sourceField: 'id' },
            ]
        },
        // Set static values and resolve nSeries from state (settings are merged into state by PageView)
        {
            operationType: 'changeValues',
            fields: [
                { targetField: 'entity',       toValue: 'invoice' },
                { targetField: 'state',        toValue: 'draft' },
                { targetField: 'date',         toValue: '{today}' },
                { targetField: 'number',       toValue: 'settings/nSeries/invoice/nextValue' },
                { targetField: 'bookedNumber', toValue: 'DRAFT' },
                { targetField: 'nSerie',       toValue: 'settings/nSeries/invoice/id' },
            ]
        },
        {
            operationType: 'deleteFields',
            fields: ['id']
        },
        {
            operationType: 'buildLinesFromArray',
            sourceArray: 'selectedItems',
            targetArray: 'lines',
            fieldMap: [
                { targetField: 'itemName',      sourceField: 'title' },
                { targetField: 'itemDescription', sourceField: 'description' },
                { targetField: 'itemQuantity',  sourceField: 'effortQuantity' },
                { targetField: 'unitId',        toValue: 'HOUR' },
                { targetField: 'netSalesPrice', sourceField: 'itemNetPrice' },
                { targetField: 'itemTaxId', sourceField: 'itemTaxId' },
                { targetField: 'itemTaxName', sourceField: 'itemTaxName' },
                { targetField: 'itemTaxRate', sourceField: 'itemTaxRate' },
                { targetField: 'referenceId', sourceField: 'id' }
            ]
        }
    ],
    productToItemPrice: [
        {
            operationType: 'addFields',
            fields: [
                {
                    targetField: 'originalPrice',
                    sourceField: 'netSalesPrice'
                },
                {
                    targetField: 'productId',
                    sourceField: 'id'
                },
                {
                    targetField: 'productName',
                    sourceField: 'name'
                },
            ]
        }
    ]
}

export default transitionLogicData